export type ModelStatus = 'active' | 'archived' | 'hidden' | 'blacklisted'

export type CatalogFilterStatus = 'active' | 'pinned' | 'archived' | 'hidden' | 'blacklisted' | 'all'

export interface CatalogCategory {
  id: string
  name: string
  slug: string
}

export interface CatalogProvider {
  id: string
  name: string
}

export interface CatalogPricing {
  inputPerMillion: number
  outputPerMillion: number
  isFree: boolean
}

export interface CatalogModel {
  id: string
  categoryId: string
  providerId: string
  providerName: string
  displayName: string
  slug: string
  description: string
  contextWindow: number
  pricing: CatalogPricing
  status: ModelStatus
  isPinned: boolean
  categoryScore: number
  userScore: number
  features: {
    toolCalling: boolean
    vision: boolean
    streaming: boolean
  }
}

export interface CatalogFilters {
  status: CatalogFilterStatus
  freeOnly: boolean
  maxPrice: number | null
  providers: string[]
}

export const DEFAULT_CATALOG_FILTERS: CatalogFilters = {
  status: 'active',
  freeOnly: false,
  maxPrice: null,
  providers: [],
}
